(function( $ ) {
    $("#i2-azon-setting-tab a.nav-tab").on('click', function(e){
        e.preventDefault();
        var obj = $(this);
        var activeTab =  $(".tab-content.active");
        console.log(activeTab, obj.attr("href"));
       if(activeTab.attr("id") !== obj.attr("href")){
        $(".nav-tab-wrapper > a").each(function(){
             if($(this).hasClass("nav-tab-active")){
                $(this).removeClass("nav-tab-active");
             }
        });
        obj.addClass("nav-tab-active");
        
           console.log("testing");
        var targetTab = $(obj.attr("href"));   

        if(targetTab.length > 0 && activeTab.length > 0){
            activeTab.removeClass("active");          
            activeTab.fadeOut('fast', function(){
                targetTab.fadeIn('slow', function(){
                    targetTab.addClass('active');
                })
            } );
        }else{
            if(activeTab.length > 0){
                console.log("inside active tab " + targetTab);
                activeTab.removeClass("active"); 
                activeTab.fadeOut('fast');
            }
            if(targetTab.length > 0){
                console.log("inside target tab " + targetTab);
                targetTab.fadeIn();
                targetTab.addClass('active');
            } 
        }

        // $("#" + activeTab.attr("id")).fadeOut(400, $(obj.attr("href")).fadeIn());
       }

    });

    $(".tf-show-hidden-field").on('click', function(e){
        e.preventDefault();
        var obj = $(this);
       // console.log($(this).data('id'));
        var input = $("#" + obj.data('id'));
        if(input.attr("type") == 'password'){
            input.attr("type", "text");
            obj.text("Hide");
        }else{
            input.attr("type", 'password');
            obj.text("Show");
        }
		});
		

		$("#i2_azon_options_add_proxy_link").on('change', function () {
			 //console.log(this)
			 $(".i2azon-proxy").parentsUntil("tr").parent().toggle();
		});

		$("#i2_azon_options_use_amazon_api_key").on('change', function () {
			//console.log(this)
			$(".i2azon-partner").parentsUntil("tr").parent().toggle();
	 });

		function hide_i2azon_hidden () {
			$(".i2azon-hidden").parentsUntil("tr").parent().hide();
		}
    hide_i2azon_hidden();

})(jQuery);